module.exports = __webpack_public_path__ + "static/img/1-open-new1.0cbb36c1.png";